// utils/queryClient.js
import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Default options for queries
      refetchOnWindowFocus: false,
    },
  },
});
